export default __webpack_public_path__ + "static/media/hero-slider.68c5479b.jpg";